export const defaultContent = {
  home: {
    categories_topics_list: [],
    trending: {
      title: 'Trending'
    }
  },
  hub: {
    category: {
      email: {
        title: 'Get Instant Access',
        description: 'Join our list and get exclusive offers, FREE Boxing and Kickboxing training tips & tricks, and endless health & fitness inspo to inspire the fighter within.',
        button: 'Sign Me Up!',
      },
    }
  },
  article: {
    email: {
      title: 'Get Instant Access',
      description: 'Join our list and get exclusive offers, FREE Boxing and Kickboxing training tips & tricks, and endless health & fitness inspo to inspire the fighter within.',
      button: 'Sign Me Up!',
    },
  }
};
